import type { FeatureGroup } from '../types';
import { FeatureGroupEnum } from '../types';

/**
 * Expects an array of feature groups and returns a new array of feature groups
 * sorted by their hierarchical order.
 */
export function sortFeatureGroups(featureGroups: FeatureGroup[]): FeatureGroup[] {
  return featureGroups.sort((a, b) => FeatureGroupEnum[a] - FeatureGroupEnum[b]);
}
